import React, { Component } from "react";
import {
  Form,
  Segment,
  Dimmer,
  List,
  Message,
  Button,
} from "semantic-ui-react";
import ReactTable from "react-table";
import axios from "axios";

import { connect } from "react-redux";
import { addSystem, removeSystem, updateStatedIncome } from "@cb/duck/systems";
import { setLoading } from "@cb/duck/basic";
import { updateSalesperson } from "@cb/duck/salesperson";

import { prevButton, nextButton } from "components/shared/TablePagination";

import { varietyFilters } from "./helpers";
import ViewOnly from "./ViewOnly";
import AddModal from "./AddModal";
import IncomeInput from "./IncomeInput";

class Systems extends Component {
  state = {
    activeFilter: 0,
    activeVarietyFilter: 0,
    addModalData: null,
    error: null,
    loading: true,
    override: false,
    pages: null,
    pricingTiers: [],
    salespeople: [],
    selectedSystems: [],
    tableData: [],
  };

  table = React.createRef();

  componentDidMount = () => {
    this.setState({ incomeAmount: this.props.statedIncome || "" });
    this.fetchSalespeople();
    this.fetchTiers();
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.statedIncome !== this.props.statedIncome) {
      this.setState({ statedIncome: this.props.statedIncome }, () =>
        this.onFetchData(this.table.current.state)
      );
    }

    if (
      JSON.stringify(prevProps.contractSystems) !==
      JSON.stringify(this.props.contractSystems)
    ) {
      this.onFetchData(this.table.current.state);
    }

    if (prevProps.dealerTieredPricing !== this.props.dealerTieredPricing) {
      this.onFetchData(this.table.current.state);
    }
  };

  fetchSalespeople = () => {
    this.props.dispatch(setLoading(true));
    axios
      .get("/salespeople/")
      .then(({ data }) => {
        this.setState({
          salespeople: data,
        });
      })
      .then(() => this.props.dispatch(setLoading(false)))
      .catch((err) => {});
  };

  fetchTiers = () => {
    const { dealerId } = this.props;

    const req = {
      dealer_id: dealerId,
    };

    axios.post(`/dealer-pricing-tiers/`, req).then(({ data }) => {
      this.setState({
        pricingTiers: data.pricebook_tier_links
          .sort((a, b) => (a.position > b.position ? 1 : -1))
          .map((p) => ({
            name: p.tier_name,
            id: p.pricing_tier_id,
            position: p.position,
          })),
      });
    });
  };

  onFetchData = (
    state,
    instance,
    activeFilter = this.state.activeFilter,
    activeVarietyFilter
  ) => {
    const { page, pageSize, sorted, filtered } = state;

    this.setState({ loading: true });

    let postUrl = "/retrieve-default-systems/";

    const postData = {
      contract_id: this.props.id,
      page: page * pageSize,
      page_size: pageSize,
      sorted,
      filtered,
      status: activeFilter,
      variety:
        activeVarietyFilter !== undefined
          ? activeVarietyFilter
          : this.state.activeVarietyFilter,
    };

    if (!this.props.defaultPricebook) {
      postUrl = `/retrieve-systems/`;
    }

    axios
      .post(postUrl, postData)
      .then(({ data }) => {
        let numPages = 0;

        if (data.total < pageSize) {
          numPages = 1;
        } else {
          numPages = Math.ceil(data.total / pageSize);
        }

        this.setState({
          tableData: formatTierData(data.data),
          pages: numPages,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          error: {
            header: "There was an error",
            text: "Error Loading Systems",
          },
        });
      });
  };

  onSystemAddClick = (e = null, joinId, hvacSystemId) => {
    const systemInTier = this.getSystemInTier(hvacSystemId, joinId);

    if (e) {
      e.preventDefault();
    }

    if (!systemInTier) return;

    this.setState({ addModalData: systemInTier });
  };

  onSystemAddConfirm = (dealerRequestedAmount) => {
    const systemInTier = this.state.addModalData;

    if (this.state.override && !systemInTier.allow)
      return this.onOverrideSystemAddClick(systemInTier);

    this.props.dispatch(
      addSystem(systemInTier, this.props.id, {
        dealer_requested_amount: dealerRequestedAmount,
      })
    );
    this.setState({ addModalData: null });
  };

  getSystemInTier = (hvacSystemId, joinId) => {
    const system = this.state.tableData.find(
      (s) => s.hvac_system_id === hvacSystemId
    );
    if (!system) return null;
    const systemInTier = system.systems.find((s) => s.id === joinId);
    if (!systemInTier) return null;
    return systemInTier;
  };

  onSystemRemoveClick = (e, joinId, hvacSystemId) => {
    // let selectedSystems = [...this.state.selectedSystems];
    // let idx = selectedSystems.findIndex((s) => s.id === joinId);

    // selectedSystems.splice(idx, 1);

    const systemInTier = this.getSystemInTier(hvacSystemId, joinId);

    if (!systemInTier) return;

    this.props.dispatch(removeSystem(joinId, this.props.id));
  };

  onSystemTrashClick = (e, systemId) => {
    let selectedSystems = [...this.state.selectedSystems];
    let idx = selectedSystems.findIndex((s) => s.id === systemId);

    selectedSystems.splice(idx, 1);

    this.props.dispatch(removeSystem(systemId, this.props.id));
  };

  onVarietyFilterClick = (activeVarietyFilter) => {
    this.setState({ activeVarietyFilter });

    this.table.current.state.page = 0;

    this.onFetchData(
      this.table.current.state,
      null,
      this.state.activeFilter,
      activeVarietyFilter
    );
  };

  onSalespersonSelect = (id) => {
    const salesperson = this.state.salespeople.find((d) => d.id === id);

    if (!salesperson) {
      return;
    }

    this.props.dispatch(updateSalesperson(salesperson, this.props.id));
  };

  onIncomeChange = (e) => {
    this.setState({ incomeAmount: e.target.value });
  };

  onIncomeSubmit = (e) => {
    e.preventDefault();

    this.props.dispatch(
      updateStatedIncome(this.props.id, this.state.incomeAmount)
    );
  };

  render() {
    const { loading, pages, pricingTiers, tableData } = this.state;
    const {
      contractSystems,
      defaultPricebook,
      dealerTieredPricing,
      statedIncome,
    } = this.props;

    const override = false;

    const defaultPricingTierId = pricingTiers.find((t) => t.position === 1)
      ? pricingTiers.find((t) => t.position === 1).id
      : null;

    const alacarteSelected = contractSystems.find((s) => s.variety === 4);
    let alacarteComponentCode = alacarteSelected
      ? contractSystems.find((s) => s.variety === 4).component_code
      : null;

    const { salesperson } = this.props;

    const salespersonOptions = this.state.salespeople.map((s) => {
      return {
        key: s.id,
        text: `${s.first_name} ${s.last_name}`,
        value: s.id,
      };
    });

    let columns = [
      {
        Header: "Name",
        id: "system_name",
        width: 340,
        accessor: "name",
        filterable: false,
        sortable: false,
      },
    ];

    if (dealerTieredPricing && !defaultPricebook) {
      const tierGroup = {
        Header: "Tiers",
        columns: [],
      };

      pricingTiers.forEach((tier) => {
        tierGroup.columns.push({
          Header: tier.name,
          id: `tier${tier.id}`,
          filterable: false,
          sortable: false,
          accessor: (sys) => {
            const sysInTier = sys.systems.find(
              (s) => s.pricing_tier_id === tier.id
            );

            if (sysInTier) {
              const quantity = contractSystems.filter(
                (s) => s.id === sysInTier.id
              ).length;

              const addDisabled =
                sys.variety === 4 &&
                alacarteSelected &&
                sys.component_code !== alacarteComponentCode;

              if (
                sysInTier.price_formatted &&
                sysInTier.price_formatted === "0.00"
              )
                return "";

              return (
                <SystemCell
                  allow={override || sysInTier.allow}
                  addDisabled={addDisabled}
                  removeDisabled={quantity <= 0}
                  quantity={quantity}
                  price={`$${sysInTier.price_formatted}`}
                  override={override && !sysInTier.allow}
                  onAdd={(e) =>
                    this.onSystemAddClick(
                      e,
                      sysInTier.id,
                      sysInTier.hvac_system_id
                    )
                  }
                  onRemove={(e) =>
                    this.onSystemRemoveClick(
                      e,
                      sysInTier.id,
                      sysInTier.hvac_system_id
                    )
                  }
                />
              );
            } else {
              return "";
            }
          },
        });
      });

      columns.push(tierGroup);
    } else {
      columns.push({
        Header: "",
        width: 50,
        sortable: false,
        filterable: false,
        id: "price",
        accessor: (sys) => {
          const quantity = contractSystems.filter(
            (s) => s.id === sys.id
          ).length;

          const allowSys = sys.systems.find(
            (s) => s.allow && s.pricing_tier_id === defaultPricingTierId
          );

          const unallowSystem = sys.systems.find(
            (s) => !s.allow && s.pricing_tier_id === defaultPricingTierId
          );

          if (!allowSys && !unallowSystem) return "";

          if (unallowSystem) {
            if (
              unallowSystem.price_formatted &&
              unallowSystem.price_formatted === "0.00"
            )
              return "";

            return (
              <SystemCell
                removeDisabled={true}
                addDisabled={true}
                allow={false}
                price={`$${unallowSystem.price_formatted}`}
              />
            );
          }

          const addDisabled =
            sys.variety === 4 &&
            alacarteSelected &&
            sys.component_code !== alacarteComponentCode;

          if (allowSys.price_formatted && allowSys.price_formatted === "0.00")
            return "";

          return (
            <SystemCell
              addDisabled={addDisabled}
              removeDisabled={quantity <= 0}
              quantity={quantity}
              price={`$${allowSys.price_formatted}`}
              onAdd={(e) =>
                this.onSystemAddClick(e, allowSys.id, sys.hvac_system_id)
              }
              onRemove={(e) =>
                this.onSystemRemoveClick(e, allowSys.id, sys.hvac_system_id)
              }
            />
          );
        },
      });
    }

    if (this.props.payment) {
      return <ViewOnly systems={this.props.contractSystems} />;
    }

    return (
      <div>
        <AddModal
          contractId={this.props.id}
          data={this.state.addModalData}
          onClose={() => this.setState({ addModalData: null })}
          onConfirm={this.onSystemAddConfirm}
          open={this.state.addModalData ? true : false}
        />
        {salespersonOptions.length > 0 && (
          <Segment padded>
            <Form size="large" style={{ marginBottom: "0" }}>
              <Form.Select
                placeholder="Select a salesperson..."
                search
                label="Salesperson"
                loading={this.state.loading}
                selection
                fluid
                options={salespersonOptions}
                onChange={(e, d) => this.onSalespersonSelect(d.value)}
                value={salesperson ? salesperson.id : null}
              />
            </Form>
          </Segment>
        )}
        <Segment padded>
          <IncomeInput
            incomeAmount={this.state.incomeAmount}
            onIncomeChange={this.onIncomeChange}
            onSubmit={this.onIncomeSubmit}
          />
        </Segment>
        <Segment padded>
          {!statedIncome && (
            <Message
              warning
              icon="circle exclamation"
              header="Missing Income"
              content="We're missing the customer's income per month. Fill it in above."
            />
          )}
          <Dimmer.Dimmable blurring dimmed={!statedIncome}>
            {this.props.contractSystems.length > 0 && (
              <div style={{ marginBottom: "15px" }}>
                <h4 style={{ marginBottom: "5px" }}>
                  Selected Systems ({this.props.contractSystems.length})
                </h4>
                <List size="small" divided verticalAlign="middle">
                  {this.props.contractSystems.map((sys, i) => (
                    <List.Item
                      key={i}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <List.Content floated="left">
                        <Button
                          icon="trash"
                          negative
                          circular
                          basic
                          size="mini"
                          onClick={(e) => this.onSystemTrashClick(e, sys.id)}
                        />
                      </List.Content>
                      <List.Content
                        content={`${sys.name}, $${sys.dealer_requested_amount_formatted}`}
                      />
                    </List.Item>
                  ))}
                </List>
              </div>
            )}
            {alacarteSelected && (
              <p style={{ marginTop: "20px", fontSize: "16px", width: "80%" }}>
                <b>
                  You've selected an a la carte component. If you need to add
                  another a la carte component type, remove the currently
                  selected a la carte component or choose from Split, Package,
                  or Mini-Split systems.
                </b>
              </p>
            )}
            <div style={{ marginBottom: "15px" }}>
              <h4
                style={{
                  margin: "0 0 10px 0",
                  display: "block",
                }}
              >
                Filtering systems by...
              </h4>
              {varietyFilters.map((b) => (
                <Button
                  basic={
                    this.state.activeVarietyFilter === b.value ? false : true
                  }
                  color={b.color}
                  content={b.text}
                  onClick={(e) => this.onVarietyFilterClick(b.value)}
                  key={b.value}
                />
              ))}
            </div>
            <ReactTable
              style={
                {
                  // display: !this.state.loading && !this.state.tableData.length ? 'none' : 'inherit',
                }
              }
              data={tableData}
              getTrProps={(state, rowInfo, column) => {
                if (rowInfo) {
                  return {
                    style: {
                      background: this.props.contractSystems.find(
                        (s) =>
                          s.hvac_system_id === rowInfo.original.hvac_system_id
                      )
                        ? "#0080001c"
                        : "",
                    },
                  };
                }
                return "";
              }}
              columns={columns}
              defaultPageSize={50}
              filterable
              minRows={5}
              className="-ui -striped -table"
              noDataText={`No Systems Available`}
              loadingText={`Loading Systems...`}
              loading={loading}
              rowsText={`Systems`}
              multisort={false}
              ref={this.table}
              manual
              pages={pages}
              onFetchData={this.onFetchData}
              PreviousComponent={prevButton}
              NextComponent={nextButton}
            />
          </Dimmer.Dimmable>
        </Segment>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    contractSystems: state.systems,
    dealerId: state.dealer ? state.dealer.id : null,
    dealerName: state.dealer ? state.dealer.name : null,
    defaultPricebook: state.defaultPricebook,
    dealerTieredPricing: state.dealer ? state.dealer.tiered_pricing : false,
    id: state.id,
    payment: state.payment,
    salesperson: state.salesperson,
    statedIncome: state.statedIncome,
  };
}

export default connect(mapStateToProps)(Systems);

export function formatTierData(data) {
  const systems = data.map((system) => ({
    hvac_system_id: system.hvac_system_id,
    name: system.name,
    variety: system.variety,
    component_code:
      system.component_code !== undefined ? system.component_code : null,
    systems: [
      ...system.allow.map((s) => ({
        allow: true,
        variety: system.variety,
        hvac_system_id: system.hvac_system_id,
        id: s.pricebook_join_id,
        name: system.name,
        price_formatted: s.pricebook_price_in_pennies_formatted,
        component_code:
          system.component_code !== undefined ? system.component_code : null,
        pricing_tier_id: s.pricing_tier_id,
      })),
      ...system.dont_allow.map((s) => ({
        allow: false,
        hvac_system_id: system.hvac_system_id,
        id: s.pricebook_join_id,
        name: system.name,
        variety: system.variety,
        price_formatted: s.pricebook_price_in_pennies_formatted,
        component_code:
          system.component_code !== undefined ? system.component_code : null,
        pricing_tier_id: s.pricing_tier_id,
      })),
    ],
  }));

  return systems;
}

export const SystemCell = ({
  addDisabled,
  allow,
  onAdd,
  onRemove,
  override,
  price,
  quantity,
  removeDisabled,
}) => {
  const buttonProps = {
    size: "mini",
    basic: true,
    circular: true,
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div>
        {!removeDisabled && allow && (
          <Button
            {...buttonProps}
            icon="minus"
            onClick={onRemove}
            disabled={removeDisabled}
          />
        )}
        {/* <span style={{ margin: "0 5px" }}>{quantity}</span> */}
        {/* <span
          style={{
            margin: "0 5px",
            fontWeight: "bold",
            textDecoration: !allow ? "line-through" : "none",
            opacity: !allow ? "0.35" : "1",
            color: override ? "red" : "inherit",
          }}
        >
          {price}
        </span> */}
        {allow && (
          <Button
            {...buttonProps}
            icon="plus"
            onClick={onAdd}
            disabled={addDisabled}
          />
        )}
      </div>
    </div>
  );
};

SystemCell.defaultProps = {
  addDisabled: false,
  allow: true,
  price: "",
  removeDisabled: false,
};
